import { createUseStyles } from 'react-jss';

const styles = {
  conversationInput: {
    margin: '0.3rem 0'
  },
  buttonsContainer: {
    '& ui5-button': {
      margin: '0 0.3rem'
    },
    display: 'flex',
    padding: '0.5rem',
    justifyContent: 'right'
  },
  characterCounter: {
    marginBottom: '0.3rem',
    display: 'flex',
    flexDirection: 'row-reverse'
  },
  conversationTimeline: {
    marginBottom: '0.5rem'
  },
  buttonRequestClarification: {
    backgroundColor: '#FFF',
    borderColor: '#F09D54',
    color: '#F09D54'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'QueryConversation'
});
